import { render, staticRenderFns } from "./history.vue?vue&type=template&id=fc578da2&"
import script from "./history.vue?vue&type=script&lang=js&"
export * from "./history.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Projects\\008-QLK_FE\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('fc578da2')) {
      api.createRecord('fc578da2', component.options)
    } else {
      api.reload('fc578da2', component.options)
    }
    module.hot.accept("./history.vue?vue&type=template&id=fc578da2&", function () {
      api.rerender('fc578da2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/work-submit/history.vue"
export default component.exports